import type { TypedMyBrandMap } from './-MyBrandMap';
import RawMyBrandMap from './MyBrandMap.vue';
export * from './-MyBrandMap';
export const MyBrandMap = RawMyBrandMap as typeof TypedMyBrandMap;
